export const GET_CATEGORIES_REQUEST = "GET_CATEGORIES_REQUEST";
export const SAVE_ATTR = 'SAVE_ATTR'
export const INSERT_CATEGORY = 'INSERT_CATEGORY'
export const DELETE_CATEGORY = 'DELETE_CATEGORY'